module.exports = __webpack_public_path__ + "img/stock6.5e38bd7c.png";